export default __webpack_public_path__ + "static/media/sandero-colour-1.1f49a362.jpg";